import React, {useState} from 'react'
import {Button, Divider, message} from 'antd'
import {GoogleCircleFilled} from '@ant-design/icons'
import {Link, redirect, useNavigate} from 'react-router-dom'
import {instance as userService} from '../../services/UserService'
import {useIntl} from 'react-intl'
import {SignUpForm} from './SignUpForm'
import './loginPage.less'

export function SignUpPage() {
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage()
  const [isEmailSent, setEmailSent] = useState(false)
  const intl = useIntl()
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="container">
        <Link className="logo" to="/">
          <h1>TerraSketch</h1>
        </Link>
        <h2>{intl.formatMessage({id: 'signUp'})}</h2>
        {isEmailSent ? (
          <div className="email-check">
            <div>{intl.formatMessage({id: 'checkYourEmail'})}</div>
            <Button
              size="large"
              type="primary"
              onClick={async () => {
                navigate('/login')
              }}
            >
              {intl.formatMessage({id: 'ok'})}
            </Button>
          </div>
        ) : (
          <>
            <SignUpForm setEmailSent={setEmailSent}></SignUpForm>
            <Divider />
            <Button
              icon={<GoogleCircleFilled />}
              size="large"
              onClick={async () => {
                const result = await userService.signUpGoogle()
                if (!result.success) {
                  messageApi.open({
                    type: 'error',
                    content: result.error.message,
                  })
                } else {
                  navigate('/home')
                }
              }}
            >
              {intl.formatMessage({id: 'signUpWithGoogle'})}
            </Button>
            <div
              style={{
                textAlign: 'center',
              }}
            >
              <div>{intl.formatMessage({id: 'byClickingSignUpWithGoogle'})} </div>
              <Link to="/#">{intl.formatMessage({id: 'policyTerrasketch'})}</Link>
            </div>
            <Divider />
            <div
              style={{
                textAlign: 'center',
              }}
            >
              <div>{intl.formatMessage({id: 'ifYouHaveAccount'})}</div>
              <Link to="/login">{intl.formatMessage({id: 'logIn'})}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
